var map = {
	"./NextSong.svg": "31c0",
	"./Previous.svg": "f5ff",
	"./RTK.svg": "d27e",
	"./RTU.svg": "26ba",
	"./arrow-left.svg": "56d8",
	"./arrow.svg": "200f",
	"./audio.svg": "e785",
	"./battery.svg": "ca2a",
	"./camera.svg": "921f",
	"./channel.svg": "f438",
	"./check.svg": "2e14",
	"./close.svg": "cbd3",
	"./codec.svg": "7e1e",
	"./delete.svg": "1275",
	"./download.svg": "45f6",
	"./edit.svg": "d010",
	"./empty.svg": "1812",
	"./error.svg": "70f6",
	"./fix_.svg": "4d9b",
	"./form.svg": "bca5",
	"./frequency.svg": "fde4",
	"./lidar_.svg": "b703",
	"./list.svg": "c713",
	"./loopPlayback.svg": "efa4",
	"./module.svg": "bc34",
	"./motor.svg": "c8ca",
	"./musicIcon.svg": "fc86",
	"./mute.svg": "8434",
	"./noMute.svg": "c376",
	"./pause.svg": "a8b1",
	"./play.svg": "48c7",
	"./playlist.svg": "3582",
	"./plus.svg": "54e5",
	"./quickMenu.svg": "2311",
	"./random.svg": "e9f6",
	"./refresh.svg": "0760",
	"./robot.svg": "493e",
	"./save.svg": "2b8e",
	"./sequential.svg": "cadc",
	"./settings.svg": "c864",
	"./stopPlaying.svg": "5c93",
	"./success.svg": "f956",
	"./sync.svg": "ad77",
	"./upload.svg": "15df",
	"./volume.svg": "16b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5306";